import NoSamp from "@/views/samp/nosamp/NoSamp"
export const nosamp = {
    path: '/nosamp',
    name: 'NoSamp',
    component: NoSamp
  }


// WEBPACK FOOTER //
// ./src/router/index/samp/nosamp/index.js